/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_NovInputs */

const en_better_studio_month_nov = /** @type {(inputs: Better_Studio_Month_NovInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nov`)
};

/**
* | output |
* | --- |
* | "Nov" |
*
* @param {Better_Studio_Month_NovInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_nov = /** @type {((inputs?: Better_Studio_Month_NovInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_NovInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_nov(inputs)
});